import { useState } from 'react';

interface FamiliaritySelectorProps {
  isFamiliar?: boolean;
  onSubmit: (isFamiliar: boolean, updatedByUser: boolean) => void;
  disabled?: boolean;
}

export function FamiliaritySelector({ 
  isFamiliar: initialFamiliar, 
  onSubmit, 
  disabled = false 
}: FamiliaritySelectorProps) {
  const [isFamiliar, setIsFamiliar] = useState(initialFamiliar ?? true);
  const [hasChanged, setHasChanged] = useState(false);
  
  const handleChange = (value: boolean) => {
    setIsFamiliar(value);
    if (initialFamiliar !== undefined) {
      setHasChanged(value !== initialFamiliar);
    }
  };
  
  const handleSubmit = () => {
    onSubmit(isFamiliar, hasChanged);
  };
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="font-bold text-lg mb-4">歌曲熟悉度</h3>
      <p className="text-gray-600 mb-4">
        请问您是否熟悉这两首歌曲？这将帮助我们更好地理解评估结果。
      </p>
      
      <div className="flex gap-4 mb-4">
        <button
          onClick={() => handleChange(true)}
          disabled={disabled}
          className={`flex-1 py-3 px-4 rounded-lg border-2 transition-all ${
            isFamiliar
              ? 'border-sky-500 bg-sky-50 text-sky-700 font-medium'
              : 'border-gray-300 hover:border-gray-400'
          } disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          熟悉
        </button>
        <button
          onClick={() => handleChange(false)}
          disabled={disabled}
          className={`flex-1 py-3 px-4 rounded-lg border-2 transition-all ${
            !isFamiliar
              ? 'border-sky-500 bg-sky-50 text-sky-700 font-medium'
              : 'border-gray-300 hover:border-gray-400'
          } disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          不熟悉
        </button>
      </div>
      
      {hasChanged && (
        <div className="text-sm text-amber-600 mb-2">
          您修改了系统的预测结果
        </div>
      )}
      
      <button
        onClick={handleSubmit}
        disabled={disabled}
        className="w-full bg-sky-500 hover:bg-sky-600 text-white font-medium py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        提交熟悉度
      </button>
    </div>
  );
}

